// Methods not using "this" are implementing the interface and cannot be static
/* eslint-disable class-methods-use-this */

import { AxiosResponse } from 'axios';
import VersionedResource from '../VersionedResource';
import { DelinquentSettings } from './loanaccounts/DelinquentSettings';
import { StatusSettingsResource } from '../accountstatussettings/StatusSettingsResource';
import { StatusSettings } from '../accountstatussettings/StatusSettings';

export class DelinquentSettingsResource extends VersionedResource implements StatusSettingsResource {
  public async save(fiId: string, settings: DelinquentSettings): Promise<DelinquentSettings> {
    const url = `/api/rcx/config/${fiId}/loan-account-settings/delinquent`;

    const response: AxiosResponse = await this.apiClient.put(url, settings);
    return response.data.data;
  }

  createEmptySettings(): DelinquentSettings {
    return {
      statusCodes: [],
      active: true,
    };
  }

  setIndicatorsOnSettings(settings: StatusSettings, values: string[], conditionalOr: boolean | null) {
    // Does nothing. Delinquent settings are always "status code"
  }

  getIndicatorsFromSettings(settings: StatusSettings): string[] | null {
    return ['STATUS_CODE'];
  }

  getConditionalFromSettings(settings: StatusSettings): string | null {
    return null;
  }
}

export default DelinquentSettingsResource;
